export var ContentWidth = /*#__PURE__*/ function(ContentWidth) {
    ContentWidth["CONTENT_WIDTH_UNKNOWN"] = "CONTENT_WIDTH_UNKNOWN";
    /**
   * 1280px on desktop web. Used for standard homepage and category pages.
   */ ContentWidth["DESKTOP_STANDARD"] = "DESKTOP_STANDARD";
    /**
   * 1376px on desktop web. Equivalent to 1440px (XL breakpoint) minus 32px padding.
   */ ContentWidth["DESKTOP_LARGE"] = "DESKTOP_LARGE";
    /**
   * 1920px on desktop web.
   */ ContentWidth["DESKTOP_XLARGE"] = "DESKTOP_XLARGE";
    return ContentWidth;
}({});
